import React, { ReactNode } from 'react';
import ChowdeckIcon from 'assets/images/chowdeck.png';
import { ReactComponent as GlovoIcon } from 'assets/icons/glovo-icon.svg';
import { ENUM_BRAND_TYPE } from './enum';
import { BrandType, SearchType } from './types';
import PrivateIcon from 'assets/icons/private-icon.svg';

const BrandTypeConfig: Partial<Record<ENUM_BRAND_TYPE, ReactNode>> = {
  [ENUM_BRAND_TYPE.GLOVO]: (
    <GlovoIcon className='w-[26px] h-[26px] absolute z-50 top-10 right-0 rounded-full border-[1.5px] border-[#FFFFFF]  object-cover' />
  ),
  [ENUM_BRAND_TYPE.CHOWDECK]: (
    <img
      src={ChowdeckIcon}
      alt='chodeck-logo'
      className='w-[26px] h-[26px] absolute z-50 top-10 right-0 rounded-full border-[1.5px] border-[#FFFFFF]  object-cover'
    />
  ),
  [ENUM_BRAND_TYPE.FOODCOURT]: (
    <img
      className='w-[26px] h-[26px] absolute z-50 top-10 right-0 rounded-full border-[1.5px] border-[#FFFFFF]  object-cover'
      src={PrivateIcon}
    />
  )
};

export const getBrandType = (brand: BrandType | SearchType): ReactNode => {
  if (!brand?.is_private || !brand?.brand_type) return null;
  return BrandTypeConfig[brand?.brand_type];
};
